import { useState } from "react";
import { Quote, ChevronLeft, ChevronRight, Star } from "lucide-react";

const testimonials = [
  {
    quote:
      "We interviewed five ID firms before Noah+Rayn. Their quote came in lower, but somehow we got more — better tiles, deeper carpentry, calmer site days. Our 5-room feels like a boutique hotel.",
    name: "Aisyah & Faiz",
    home: "5-Room BTO · Tengah",
    rating: 5,
  },
  {
    quote:
      "What sold us was how Awi spoke about our living room — not in spec sheets, but in mood. The result is exactly that: a room that makes you want to stay in it.",
    name: "The Tan Family",
    home: "Resale · Bishan",
    rating: 5,
  },
  {
    quote:
      "Honest pricing, no last-minute upsells. They renovated like it was their own home. We've already referred two cousins.",
    name: "Devi & Arjun",
    home: "4-Room BTO · Punggol",
    rating: 5,
  },
  {
    quote:
      "Hacking, tiling, wallpaper, carpentry — all under one team. We dealt with one person from day one. That alone was worth it.",
    name: "Marcus L.",
    home: "Resale · Toa Payoh",
    rating: 5,
  },
];

export const Testimonials = () => {
  const [idx, setIdx] = useState(0);
  const t = testimonials[idx];

  const prev = () => setIdx((i) => (i - 1 + testimonials.length) % testimonials.length);
  const next = () => setIdx((i) => (i + 1) % testimonials.length);

  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="relative bg-[color:var(--nr-bg-soft)] py-24 md:py-32"
    >
      <div className="max-w-[1100px] mx-auto px-6 lg:px-10 text-center">
        <p className="overline mb-5">Client voices</p>
        <h2 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.02] text-[color:var(--nr-ink)] mb-16">
          Trust, passed down{" "}
          <em className="italic font-light text-[color:var(--nr-accent)]">
            one home at a time
          </em>
          .
        </h2>

        <div className="relative reveal">
          <Quote
            size={64}
            className="mx-auto text-[color:var(--nr-accent)]/30 mb-8"
          />
          <blockquote
            data-testid="testimonial-quote"
            key={idx}
            className="font-serif-display text-2xl sm:text-3xl lg:text-4xl leading-snug text-[color:var(--nr-ink)] max-w-3xl mx-auto italic font-light"
          >
            "{t.quote}"
          </blockquote>

          <div className="flex items-center justify-center gap-1 mt-8">
            {Array.from({ length: t.rating }).map((_, i) => (
              <Star
                key={i}
                size={16}
                className="fill-[color:var(--nr-accent)] text-[color:var(--nr-accent)]"
              />
            ))}
          </div>

          <div className="mt-5 text-[color:var(--nr-ink)] font-semibold">
            {t.name}
          </div>
          <div className="text-sm text-[color:var(--nr-ink-soft)]">
            {t.home}
          </div>

          <div className="flex items-center justify-center gap-3 mt-10">
            <button
              data-testid="testimonial-prev"
              onClick={prev}
              aria-label="Previous testimonial"
              className="w-11 h-11 rounded-full border border-[color:var(--nr-line)] flex items-center justify-center hover:bg-[color:var(--nr-bg)] transition-colors"
            >
              <ChevronLeft size={18} />
            </button>
            <div className="flex gap-1.5">
              {testimonials.map((_, i) => (
                <button
                  key={i}
                  data-testid={`testimonial-dot-${i}`}
                  onClick={() => setIdx(i)}
                  aria-label={`Go to testimonial ${i + 1}`}
                  className={`h-1.5 rounded-full transition-all duration-300 ${
                    idx === i
                      ? "w-8 bg-[color:var(--nr-accent)]"
                      : "w-1.5 bg-[color:var(--nr-ink)]/20"
                  }`}
                />
              ))}
            </div>
            <button
              data-testid="testimonial-next"
              onClick={next}
              aria-label="Next testimonial"
              className="w-11 h-11 rounded-full border border-[color:var(--nr-line)] flex items-center justify-center hover:bg-[color:var(--nr-bg)] transition-colors"
            >
              <ChevronRight size={18} />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};
